var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentionEmailBridgeUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16340_77693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.9751C9.24 6.9751 7 9.2151 7 11.9751C7 14.7351 9.24 16.9751 12 16.9751H14.5V15.9751H12C9.83 15.9751 8 14.1451 8 11.9751C8 9.8051 9.83 7.9751 12 7.9751C14.17 7.9751 16 9.8051 16 11.9751V12.6901C16 13.0851 15.645 13.4751 15.25 13.4751C14.855 13.4751 14.5 13.0851 14.5 12.6901V11.9751C14.5 10.5951 13.38 9.4751 12 9.4751C10.62 9.4751 9.5 10.5951 9.5 11.9751C9.5 13.3551 10.62 14.4751 12 14.4751C12.69 14.4751 13.32 14.1951 13.77 13.7401C14.095 14.1851 14.655 14.4751 15.25 14.4751C16.235 14.4751 17 13.6751 17 12.6901V11.9751C17 9.2151 14.76 6.9751 12 6.9751ZM12 13.4751C11.17 13.4751 10.5 12.8051 10.5 11.9751C10.5 11.1451 11.17 10.4751 12 10.4751C12.83 10.4751 13.5 11.1451 13.5 11.9751C13.5 12.8051 12.83 13.4751 12 13.4751Z",
    fill: "#677487"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "#677487"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16340_77693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionEmailBridgeUnselected);
export default __webpack_public_path__ + "static/media/mentionEmailBridgeUnselected.4d916ec4b2cfb605d58f437fd53529e5.svg";
export { ForwardRef as ReactComponent };